module.exports = __webpack_public_path__ + "static/media/AE.60a4a62f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AE.svg
// module id = 2094
// module chunks = 7